'use client'

import { SilentErrorFallback } from '@/src/components/common/silent-error-boundary'
import { useSchedule } from '@/src/lib/hooks/useSchedule'
import { Clock } from 'lucide-react'
import { ErrorBoundary } from 'next/dist/client/components/error-boundary'
import { Suspense } from 'react'

function LocationScheduleContent() {
  const { data: schedule } = useSchedule()

  return (
    <div className="flex items-start gap-3">
      <Clock className="text-srperrito-cream mt-1 flex-shrink-0" />
      <div className="w-full max-w-[220px]">
        {schedule?.days?.map((hour, index) => (
          <div key={index} className="mb-3 last:mb-0">
            <div className="font-medium text-srperrito-cream mb-1">{hour.days}</div>
            {hour.shifts.length === 1
              ? (
                  <div className="text-srperrito-cream/80">{hour.shifts[0]}</div>
                )
              : (
                  <div className="grid grid-cols-2 gap-2">
                    {hour.shifts.map((shift, shiftIndex) => (
                      <div key={shiftIndex} className="text-srperrito-cream/80">{shift}</div>
                    ))}
                  </div>
                )}
          </div>
        ))}
        <p className="text-xs text-srperrito-cream/60 mt-3 italic">*Nuestros horarios pueden cambiar en fechas específicas, te recomendamos verificar los mismos desde Google Maps.</p>
      </div>
    </div>
  )
}

function LocationScheduleFallback() {
  return (
    <div className="text-srperrito-cream/80">
      Cargando horarios...
    </div>
  )
}

export function LocationSchedule() {
  return (
    <ErrorBoundary errorComponent={SilentErrorFallback}>
      <Suspense fallback={<LocationScheduleFallback />}>
        <LocationScheduleContent />
      </Suspense>
    </ErrorBoundary>
  )
}
